export function feetToMetres(feet: number) {
  if (isNaN(feet)) {
    return 0;
  }
  const val = feet * 0.3;
  return Number.isInteger(val) ? val : parseFloat(val.toFixed(2));
}
